import { Api } from './api';
import { EventType } from '../types/events';

export class EventsApi {
    private static readonly PATH = '/events';

    constructor(private readonly m_api: Api) {}

    public async sendEvent(type: EventType, data: string): Promise<void> {
        return this.m_api.post(`${EventsApi.PATH}/`, { type, data });
    }
}
